import { LaravelResponse, PagedSingleSelectField, laravelSelectFetchConfig, useDynamicConfig } from "@dgs/core";
import axios, { AxiosRequestConfig } from "axios";
import { FC } from "react";
import { Currency } from "../types/currency";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	clearable?: boolean;
	required?: boolean;
}

const currencyFetcher = (apiUrl: string, AxiosRequestConfig?: AxiosRequestConfig) =>
	axios.get<LaravelResponse<Currency[]>>(`${apiUrl}/currencies/options`, AxiosRequestConfig);

export const CurrencySingleSelect: FC<Props> = ({ name, label, disabled, clearable, required }) => {
	const { apiUrl } = useDynamicConfig();

	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			disabled={disabled}
			fetchConfig={laravelSelectFetchConfig(["currencies"], (search, page) =>
				currencyFetcher(apiUrl, { params: { search, page } }).then((r) => r.data),
			)}
			clearable={clearable}
			getLabel={(option) => `${option.name} (${option.isoCode})`}
			required={required}
		/>
	);
};
